import { Route, Routes } from "@angular/router";

export abstract class BaseRoutingFactory
{
    public abstract create(): Routes;
    protected abstract get coreRoute(): Routes;
    protected abstract registerChild(coreRoute: Routes, route: Route): void;
}